module.exports = __webpack_public_path__ + "static/media/ipsum_city_demo.cd3a6142.jpeg";